//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      authorsData: [
        { name: "苏轼", id: "57ad1badc4c9710054676d9d" },
        { name: "李白", id: "57b8e7ac165abd0054bf3de3" },
        { name: "陆游", id: "57b904a9d342d3005ac748fb" },
        { name: "王维", id: "57b9841f2e958a005e6bbb17" },
        { name: "杜甫", id: "57b91627165abd0054c07fc6" },
        { name: "杜牧", id: "57b9836cc4c971005593dfec" },
        { name: "屈原", id: "57b90424d342d3005ac744af" },
        { name: "柳永", id: "57b94edc2e958a005fa80261" },
        { name: "李煜", id: "57b8af7c5bbb50005b770fdd" },
        { name: "王勃", id: "57b9109fa633bd00665dcd5d" },
        { name: "李贺", id: "57b927a2128fe10054cad4c3" },
        { name: "秦观", id: "57b927b7d342d3005ac872a6" },
        { name: "曹操", id: "57b902df5bbb50005b7835f1" },
        { name: "曹植", id: "57b8eb6a79bc44005b9e1bf7" },
        { name: "李商隐", id: "57b92a9fd342d3005ac88ad5" },
        { name: "辛弃疾", id: "57b8ed682e958a005fa4d096" },
        { name: "李清照", id: "57b90879df0eea0063351b94" },
        { name: "白居易", id: "57b9247f2e958a005fa67ccb" },
        { name: "陶渊明", id: "57b8fa07c4c97100558ef104" },
        { name: "温庭筠", id: "57b93da179bc44005ba0a318" },
        { name: "欧阳修", id: "57b98d625bbb50005347ace1" },
        { name: "晏几道", id: "57b931a6df0eea00633679de" },
        { name: "刘禹锡", id: "57b922b57db2a2005427bf3a" },
        { name: "孟浩然", id: "57b9247a165abd0054c0fc61" },
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/LibraryAuthors.vue